import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import { application, telemetry } from "globals/endpoints";
import React, { useEffect, useState, useRef } from "react";
import { useQuery } from "react-query";
import loggerFactory from "globals/logger/logger-factory";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import "../../../../App.css";
import {
  useMaterialUIController,
  setClickToCall,
  setIsPreRecordBroadcast,
  setBroadCastCallType,
  setRTCEvent,
} from "context";
import { alpha } from "@mui/material/styles";
import dialog from "assets/theme/components/dialog";
import CTLDialogContent from "../../styles/CTLDialogContent";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import CTLNotification from "application/components/CTLNotification";
import { setIvrExtension } from "context";
import MapActionButtons from "../MapActionButtons";
import { setIsPublicEmergencyCall } from "context";
import GoogleMapComponent from "./GoogleMapComponent";
import LiveGroupCall from "../LiveGroupCall";

export default function GoogleMapView({
  onLoad,
  searchText,
  registerCallBacks,
  pageId,
  onContactAction,
}) {
  const Attributes = {
    enableSelectDispatcherMenu: true,
    keyField: "department",
    label: "Select Department",
    value: AuthenticationService.getDepartmentList(),
    modes: [],
  };
  const userName = AuthenticationService.getUserName();
  const UserNumber = AuthenticationService.getExtensionNumber();
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, dragAndDropEvent, darkMode, ivrExtension, dispatcherDepartment} = controller;
  const [isZDValid, setIsZDValid] = useState(true);
  const [isFileValid, setIsFileValid] = useState(true);
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [liveGroupCallOpen, setLiveGroupCallOpen] = useState(false);
  const department =  AuthenticationService?.getDepartmentList()?.map((dept) => dept.department);
  const resolveDepartmentSelection = (value, departmentMeta) => {
    const normalizedMeta =
      departmentMeta && typeof departmentMeta === "object"
        ? departmentMeta
        : value && typeof value === "object"
          ? value
          : null;

    const departmentSource = Array.isArray(
      AuthenticationService.getDepartmentList(),
    )
      ? AuthenticationService.getDepartmentList()
      : [];

    const valueAsText =
      typeof value === "string" || typeof value === "number"
        ? String(value)
        : "";

    const candidateValues = [
      normalizedMeta?.extension,
      normalizedMeta?.number,
      normalizedMeta?.value,
      valueAsText,
    ]
      .filter((item) => item !== null && item !== undefined && item !== "")
      .map((item) => String(item));

    const matchedDepartment = departmentSource.find((item) => {
      if (!item || typeof item !== "object") {
        return false;
      }

      const compareValues = [
        item.extension,
        item.value,
        item.id,
        item.number,
        item.department,
        item.departmentDescription,
        item.name,
        item.label,
      ]
        .filter((candidate) =>
          candidate !== null && candidate !== undefined && candidate !== "",
        )
        .map((candidate) => String(candidate));

      return candidateValues.some((candidate) => compareValues.includes(candidate));
    });

    // Resolve to the department CODE only (`department`). Never fall back to
    // the department name/label so `selectedDepartment === marker.department`
    // (a code comparison) stays consistent.
    const departmentCode =
      normalizedMeta?.department ||
      matchedDepartment?.department ||
      valueAsText;

    const departmentColor =
      normalizedMeta?.color || matchedDepartment?.color || "gray";

    return {
      name: departmentCode ? String(departmentCode) : "",
      color: departmentColor,
    };
  };

  // Sync with context-based department selection from Dispatcher toolbar
  useEffect(() => {
    if (!dispatcherDepartment?.value) {
      setSelectedDepartment("");
      return;
    }
    const resolved = resolveDepartmentSelection(dispatcherDepartment.value, dispatcherDepartment.meta);
    selectedDepartmentRef.current = resolved.name || "";
    setSelectedDepartment(resolved.name || "");
    setColor(resolved.color || "gray");
  }, [dispatcherDepartment]); // eslint-disable-line

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks && registerCallBacks({
      onNMSSelect: (value, departmentMeta) => {
        const resolvedDepartment = resolveDepartmentSelection(
          value,
          departmentMeta,
        );
        selectedDepartmentRef.current = resolvedDepartment.name || "";
        setSelectedDepartment(resolvedDepartment.name || "");
        setColor(resolvedDepartment.color || "gray");
      },
    });
  }, [activePage, pageId, onLoad, registerCallBacks]);

  useEffect(() => {
    setIvrExtension(dispatch, "");
  }, [activePage]);

  const componentName = "MAP";
  const imagePath = process.env.PUBLIC_URL + "/images/base.png";
  const [selectedZone, setSelectedZone] = useState(false);
  const [clickButtonName, setClickButtonName] = useState("");
  const [messageToBroadcast, setMessageToBroadcast] = useState("");
  const [message, setMessage] = useState("");
  const [selectedMarker, setSelectedMarker] = useState("");
  const [zoneList, setZoneList] = useState([]);
  const [departmentList, setDepartmentList] = useState(
    AuthenticationService.getDepartmentList(),
  );
  const [fileList, setFileList] = useState();
  const [selectZD, setSelectZD] = useState("");
  const [selectFile, setSelectFile] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const selectedDepartmentRef = useRef(selectedDepartment);
  const mapBoundsRef = useRef(null);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [open, setOpen] = useState(false);
  const [openOnCreate, setOpenOnCreate] = useState(false);
  const [groupList, setGroupList] = useState("");
  const [isDrawing, setIsDrawing] = useState(false);
  const [locationUpdateColor, setLocationUpdateColor] = useState("warn");
  const [data, setData] = useState([]);
  const [color, setColor] = useState("gray");
  const [areaData, setAreaData] = useState([]);
  const [routeData, setRouteData] = useState([]);
  const [showArea, setShowArea] = useState(
    localStorage.getItem("Show-Area") === "true",
  );
  const [showRoute, setShowRoute] = useState(
    localStorage.getItem("Show-Route") === "true",
  );
  const isDisable = AuthenticationService.allowMCXDispatcher();
  const [homeLocation, setHomeLocation] = useState(
    AuthenticationService.getLocation() || AuthenticationService.getMapCenter(),
  );
  const [mapCenterTarget, setMapCenterTarget] = useState(null);

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    localStorage.setItem("Show-Area", showArea);
  }, [showArea]);

  useEffect(() => {
    localStorage.setItem("Show-Route", showRoute);
  }, [showRoute]);

  useEffect(() => {
    getDropdownList();
  }, []);

  useEffect(() => {
    selectedDepartmentRef.current = selectedDepartment;
  }, [selectedDepartment]);

  const { refetch } = useQuery(
    ["geoTags", selectedDepartment, isDrawing],
    async () => {
      if (!isDrawing) {
        const departmentList = selectedDepartment
          ? [selectedDepartment]
          : department;
        const response = await telemetry.post(`/geoTagging/list`, {
          "departmentList": departmentList,
        });
        loggerFactory.debug(componentName, "Data tagging Received");
        setData(response.data.data);
        if (showArea) {
          const area = await application.post("/userZone/listAll");
          loggerFactory.debug(componentName, "Area Data Received");
          setAreaData(area.data.data);
        }
        if (showRoute) {
          const route = await telemetry.get("/route/listAll");
          loggerFactory.debug(componentName, "Route Data Received");
          setRouteData(route.data.data);
        }
      }
    },
    {
      refetchInterval: window.updateGeoTaggingList
        ? window.updateGeoTaggingList
        : 5000,
    },
  );

  useEffect(() => {
    refetch();
  }, []);

  const dragCallTransfer = (extensionNumber) => {
    if (extensionNumber) {
      setNotify({
        isOpen: true,
        message: "",
        type: "success",
        pagename: componentName,
        status: `Call Transfer to : ${extensionNumber}`,
      });
      window?.chrome?.webview?.postMessage(
        JSON.stringify({
          eventType: "Drag and Drop Call",
          data: extensionNumber,
        }),
      );
    } else {
      setNotify({
        isOpen: true,
        message: "",
        type: "warning",
        pagename: componentName,
        status: "Call Transfer Failed, Number Not Found!",
      });
    }
  };

  const clickToCall = (number) => {
    setClickToCall(dispatch, number);
    if (window.disablePhone) {
      setNotify({
        isOpen: true,
        message: "",
        type: "success",
        pagename: componentName,
        status: `Calling  : ${number}`,
      });
      window?.chrome?.webview?.postMessage(
        JSON.stringify({ eventType: "Call", data: number }),
      );
    } else {
      setClickToCall(dispatch, number);
    }
  };

  const clickToMessageMarker = (number) => {
    setSelectedMarker(number);
    setOpen(true);
  };

  const taskCreation = (draggedMarkerData, droppedOnMarkerData) => {
    if (droppedOnMarkerData?.userName) {
      const date = new Date();
      const formattedDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(
        date.getHours(),
      ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

      const secondDate = new Date();
      secondDate.setHours(23, 59, 0, 0);
      const expectedCompletionDate = `${secondDate.getFullYear()}-${String(
        secondDate.getMonth() + 1,
      ).padStart(2, "0")}-${String(secondDate.getDate()).padStart(
        2,
        "0",
      )} ${String(secondDate.getHours()).padStart(2, "0")}:${String(
        secondDate.getMinutes(),
      ).padStart(2, "0")}`;

      const bodyRequest = {
        tasksName: `${formattedDate} - SOS call received from ${draggedMarkerData.extensionNumber} `,
        expectedCompletionDate: expectedCompletionDate,
        taskPriority: "High",
        taskType: "urgent",
        assignedTo: 2,
        assignedUser: droppedOnMarkerData.userName,
        taskDescription: `This is an emergency call from ${draggedMarkerData.extensionNumber} , Please take action immediately to address the situation.`,
        filePath: "",
        assignedOn: formattedDate,
        currentStats: "New",
      };
      application
        .post("/task/create", bodyRequest)
        .then((response) => {
          setNotify({
            isOpen: true,
            message: response.data.messageDetail,
            type: "success",
            pagename: componentName,
            status: response.data.message,
          });
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.messageDetail,
            type: "error",
            pagename: componentName,
            status: error.response.data.message,
          });
        });
    } else {
      setNotify({
        isOpen: true,
        message: "Unable to create task for this User.",
        type: "warning",
        pagename: componentName,
        status: "The user is not valid",
      });
    }
  };


  const dragToCall = (draggedMarkerData, droppedOnMarkerData) => {
    if (!dragAndDropEvent) {
      setNotify({
        isOpen: true,
        message: "",
        type: "warning",
        pagename: componentName,
        status: "Please drag a marker with an active SOS call.",
      });
      return;
    }

    if ( dragAndDropEvent?.sender !== draggedMarkerData.extensionNumber) {
      setNotify({
        isOpen: true,
        message: "",
        type: "warning",
        pagename: componentName,
        status: "Please drag Active SOS call marker.",
      });
      return;
    }
    setNotify({
      isOpen: true,
      message: "",
      type: "success",
      pagename: componentName,
      status: `Drag & Drop Calling for : ${droppedOnMarkerData.extensionNumber}`,
    });
    const roomId = dragAndDropEvent?.roomId || dragAndDropEvent?.content?.match(/roomId:\s*([^;]+)/)?.[1]?.trim() || "";
    const payload = {
      kind: "D",
      sender: AuthenticationService.getExtensionNumber(),
      target: draggedMarkerData.extensionNumber,
      content: `roomId: ${roomId}; type: video; callType: DragAndDrop; callState: Connecting; calledTo: ${droppedOnMarkerData.extensionNumber}`,
      messageType: "call",
    };

    telemetry.post("chat/message", payload);
  };

  const onAreaCreated = async (data) => {
    const requestBody = {
      _southWest: {
        lat: data?.south,
        lng: data?.west,
      },
      _northEast: {
        lat: data?.north,
        lng: data?.east,
      },
      department: "",
      departmentList: selectedDepartmentRef.current 
          ? [selectedDepartmentRef.current]
          : department
    };
    loggerFactory.debug(
      componentName,
      "Request body for areaSelected",
      requestBody
    );
    try {
      const response = await application.post("/gis/areaSelected", requestBody);
      setNotify({
        isOpen: true,
        pagename: "MAP",
        status: "Announcement Play In Selected Area",
        type: "success",
        message: "Area Draw successfully.",
      });
    } catch (error) {
      console.error("Error in submitting area:", error);
      setNotify({
        isOpen: true,
        pagename: "Map",
        status: "Failed to Play Announcement.",
        type: "error",
        message: " Please try again.",
      });
    }
    activityLog(
      "event",
      "Announcement Play",
      "Broadcast File Play",
      UserNumber,
      "Selection Area",
      `${userName} Announcement Broadcast File Play in Selection Area`,
    );
  };

  const handleClearEmergency = async (imsi) => {
    try {
      const response = await telemetry.post(
        `/geoTagging/clearEmergency/${imsi}`,
      );
      setData((prev) =>
        prev.map((item) =>
          item.imsi === imsi
            ? {
              ...item,
              emergencyStatus: null,
            }
            : item,
        ),
      );
      setNotify({
        isOpen: true,
        message: "",
        type: "success",
        pagename: componentName,
        status: "SOS Clear Successfully",
      });
      refetch();
    } catch (error) {
      setNotify({
        isOpen: true,
        message: "",
        type: "error",
        pagename: componentName,
        status: "Failed to clear emergency",
      });

      console.error("Error clearing emergency:", error);
    }
  };

  window.handlePinDelete = (id) => {
    telemetry.post(`/geoTagging/delete/${id}`);
  };

  const getDropdownList = () => {
    application
      .post("extensions/listAllZone")
      .then((response) => {
        setZoneList(response.data.data);
      })
      .catch((error) => {
        console.error("Failed to get Zone data-", error);
      });
  };

  const getFileList = () => {
    application
      .post("announcement/listAll")
      .then((response) => {
        setFileList(response.data.data);
      })
      .catch((error) => {
        console.error("Failed to get data-", error);
      });
  };

  const announcementClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
  };

  const recordingAnnouncementClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
  };

  const pageClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
    getFileList();
  };

  const groupCallClick = (name) => {
    setSelectedZone(true);
    setClickButtonName(name);
    getDropdownList();
  };

  const messageClick = (name) => {
    setClickButtonName(name);
    setSelectedZone(true);
    getDropdownList();
  };

  const onEmergencyClick = () => {
    const number = AuthenticationService.getPublicEmergencyNumber();
    if (number) {
      if (window.disablePhone) {
        console.log("Public Emergency event data send : ", number);
        window.chrome.webview.postMessage(
          JSON.stringify({
            eventType: "PublicEmergency",
            data: number,
          }),
        );
      } else {
        setIsPublicEmergencyCall(dispatch, true);
        setClickToCall(dispatch, number);
      }
    } else {
      setNotify({
        isOpen: true,
        message: "",
        type: "info",
        pagename: componentName,
        status: "Please Define Public Emergency Number",
      });
    }
  };

  const onCloseForm = () => {
    setSelectedZone(false);
    setIsZDValid(true);
    setIsFileValid(true);
    setIsMessageValid(true);
    setMessageToBroadcast("");
    setSelectFile("");
    setSelectZD("");
  };

  const handleSelectZD = (value) => {
    setSelectZD(value);
    setIsZDValid(!!value);
  };

  const handleChangeGroup = (event) => {
    setSelectedGroup(event.target.value);
  };

  const handleFileSelect = (event) => {
    setSelectFile(event.target.value);
    setIsFileValid(!!event.target.value);
  };

  const sendMessage = async () => {
    if (!message.trim() || !selectedMarker) return;
    const payload = {
      kind: "D",
      sender: AuthenticationService.getExtensionNumber(),
      target: selectedMarker,
      content: message,
      messageType: "text",
    };
    try {
      await telemetry.post("/chat/message", payload);
      setMessage("");
      setOpen(false);
    } catch (err) {
      setNotify({
        isOpen: true,
        pagename: "Chat",
        status: "Failed to send message",
        type: "error",
      });
    }
  };

  const handleSaveButton = () => {
    const isZone = !!selectZD.zone;
    const isDepartment = !!selectZD.department;

    if (!selectZD) {
      setIsZDValid(false);
      return;
    }

    setIsZDValid(true);

    const apiEndpoint = isZone ? "zone" : isDepartment ? "department" : "";

    if (!apiEndpoint) return;

    const selectedValue = isZone ? selectZD.zone : selectZD.department;
    const number = isZone ? selectZD.extension : selectZD.extension;

    if (clickButtonName === "message") {
      if (!messageToBroadcast) {
        setIsMessageValid(false);
        return;
      }
      setIsMessageValid(true);
      setMessageToBroadcast("");

    } else if (clickButtonName === "announcement") {
      const body = { callType: "muxing", [apiEndpoint]: selectedValue };
      application.post(`extensions/call/${apiEndpoint}`, body);
      activityLog(
        "event",
        "Announcement Call",
        "Alert Call",
        UserNumber,
        selectedValue,
        `${userName} dial broadcast call in ${selectedValue}`,
      );
    } else if (clickButtonName === "page") {
      if (!selectFile) {
        setIsFileValid(false);
        return;
      }

      setIsFileValid(true);

      const body = { wavFile: selectFile, [apiEndpoint]: selectedValue };
      application.post(`extensions/play/${apiEndpoint}`, body);
      let fileName = selectFile?.split(".")[0];
      activityLog(
        "event",
        "Announcement Play",
        "Broadcast File Play",
        UserNumber,
        selectedValue,
        `${userName} Announcement Broadcast  ${selectFile} File Play in ${selectedValue}`,
      );
      setSelectFile("");
    } else if (clickButtonName === "Recording_Announcement") {
      setRTCEvent(dispatch, {
        value: selectZD.department || selectZD.zone,
        type: "announcement",
        data: number,
      });
    } else if (clickButtonName == "GroupCall") {
      setRTCEvent(dispatch, {
        value: selectZD.department || selectZD.zone,
        type: "GroupCall",
        data: number,
      });
    }
    setSelectZD("");
    setSelectedZone(false);
  };

  const activityLog = async (
    event,
    eventCategory,
    eventStatus,
    callerNumber,
    destinationNumber,
    eventData,
  ) => {
    const bodyData = {
      event: event,
      eventCategory: eventCategory,
      eventStatus: eventStatus,
      callerNumber: callerNumber,
      destinationNumber: destinationNumber,
      eventData: {
        msg: eventData,
      },
      userId: userName,
      deviceId: UserNumber,
      epochDate: Math.floor(Date.now() / 1000),
    };
    try {
      await application.post("activityLog/create", bodyData);
    } catch (error) {
      console.error("Failed to save activity log:", error);
    }
  };

  const handleMessageChange = (event) => {
    setMessageToBroadcast(event.target.value);
    setIsMessageValid(!!event.target.value);
  };

  const centerMapOnCurrentLocation = (persistLocation = false) => {
    const fallbackLocation = Array.isArray(window?.locationAsHome)
      ? [window.locationAsHome[0], window.locationAsHome[1]]
      : homeLocation;

    const moveToFallbackLocation = () => {
      if (Array.isArray(fallbackLocation)) {
        updateMAPLocation(fallbackLocation);
        if (persistLocation) {
          setHomeLocation(fallbackLocation);
        }
      }
    };

    if (navigator.geolocation) {
      if (persistLocation) {
        setLocationUpdateColor("info");
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (persistLocation) {
            showPosition(position);
            return;
          }

          const currentLocation = [
            position.coords.latitude,
            position.coords.longitude,
          ];

          loggerFactory.debug(componentName, currentLocation);
          updateMAPLocation(currentLocation);
        },
        () => {
          moveToFallbackLocation();
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
      return;
    }

    loggerFactory.debug(
      componentName,
      "Geolocation is not supported by this browser.",
    );
    moveToFallbackLocation();
  };

  const lockOnCurrentLocation = () => {
    centerMapOnCurrentLocation(true);
  };

  const navigateToLocation = () => {
    centerMapOnCurrentLocation(false);
  };

  const updateMAPLocation = (newLocation) => {
    if (!Array.isArray(newLocation) || newLocation.length < 2) {
      return;
    }

    const latitude = Number(newLocation[0]);
    const longitude = Number(newLocation[1]);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return;
    }

    setMapCenterTarget([latitude, longitude]);
  };

  function showPosition(position) {
    setLocationUpdateColor("warn");
    loggerFactory.debug(componentName, [
      position.coords.latitude,
      position.coords.longitude,
    ]);
    updateMAPLocation([position.coords.latitude, position.coords.longitude]);
    setHomeLocation([position.coords.latitude, position.coords.longitude]);
    AuthenticationService.setLocation(
      position.coords.latitude,
      position.coords.longitude,
    );
  }

  const handleMarkerMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleClickClose = () => {
    setOpen(false);
    setMessage("");
    setSelectedMarker("");
  };

  const handleOnCreateClose = () => {
    setOpenOnCreate(false);
    setSelectedGroup("");
  };

  return (
    <MDBox sx={{
      height: "100%",
      borderRadius: 3,
      overflow: "hidden",
      border: (theme) => `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
      boxShadow: (theme) => `0 16px 36px ${alpha(theme.palette.common.black, 0.24)}`,


    }}>
      <audio
        id="remoteAudio"
        autoPlay
        playsInline
        style={{ display: "none" }}
      />

      <Grid container spacing={0} sx={{ height: "100%", overflow: "hidden" }}>
        <Grid
          item
          xs
          sx={{
            height: "100%",
            borderRadius: 2.5,
            overflow: "hidden",
            position: "relative",
            background: (theme) =>
              darkMode
                ? alpha(theme.palette.background.default, 0.4)
                : alpha(theme.palette.common.white, 0.5),
          }}
        >
          {homeLocation && (
            <>
              <GoogleMapComponent
                searchText={searchText}
                color={color}
                showArea={showArea}
                showRoute={showRoute}
                setShowArea={setShowArea}
                setShowRoute={setShowRoute}
                routeData={routeData}
                areaData={areaData}
                data={data}
                clickToMessageMarker={clickToMessageMarker}
                dragCallTransfer={dragCallTransfer}
                departmentList={departmentList}
                dragToCall={dragToCall}
                onAreaCreated={onAreaCreated}
                handleClearEmergency={handleClearEmergency}
                mapCenterTarget={mapCenterTarget}
                defaultShowSearch={true}
                isDisable={isDisable}
                locationUpdateColor={locationUpdateColor}
                onRecordingPage={() =>
                  recordingAnnouncementClick("Recording_Announcement")
                }
                onPage={() => pageClick("page")}
                onDial={() => announcementClick("announcement")}
                onGroupCall={() => groupCallClick("GroupCall")}
                onLiveGroupCall={() => setLiveGroupCallOpen(true)}
                onMessage={() => messageClick("message")}
                onEmergency={() => onEmergencyClick()}
                onNavigateHome={() => navigateToLocation()}
                onAnchorLocation={() => lockOnCurrentLocation()}
                onBoundsChanged={(bounds) => {
                  mapBoundsRef.current = bounds;
                }}
                onContactAction={onContactAction}
              />
            </>
          )}
        </Grid>
        <Grid item xs="auto" sx={{ display: "none" }}>
          <Dialog
            open={selectedZone}
            onClose={onCloseForm}
            fullWidth
            maxWidth="sm"
            classes={{ dialog }}
            sx={(theme) => CTLDialogContent(theme, { darkMode })}
            PaperProps={{
              sx: (theme) => ({
                borderRadius: 3,
                overflow: "hidden",
                border: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
                boxShadow: `0 16px 36px ${alpha(theme.palette.common.black, 0.24)}`,
                ...CTLDialogContent(theme, { darkMode }),
              }),
            }}
          >
            <DialogTitle
              sx={(theme) => ({
                ...CTLDialogContent(theme, { darkMode }),
                pb: 1.5,
                borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
              })}
              id="alert-dialog-title"
            >
              <MDTypography variant="h6" fontWeight="bold" sx={{ color: "info.main" }}>
                {`Broadcast ${clickButtonName} to selected zone / department`}
              </MDTypography>
              <MDTypography variant="caption" sx={{ color: "text", mt: 0.4, display: "block" }}>
                Choose department to continue.
              </MDTypography>
            </DialogTitle>
            <DialogContent
              sx={(theme) => ({
                ...CTLDialogContent(theme, { darkMode }),
                pt: 2.5,
                display: "grid",
                gap: 1.5,
              })}
            >
              <>
                <Autocomplete
                  style={{ paddingTop: "10px" }}
                  options={[
                    ...zoneList.map((item) => ({
                      label: item.zone || item.extension,
                      group: "Zone List",
                      value: item,
                    })),
                    ...departmentList.map((item) => ({
                      label: item.department || item.extension,
                      group: "Department List",
                      value: item,
                    })),
                  ]}
                  groupBy={(option) => option.group}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) =>
                    handleSelectZD(newValue?.value || "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Department"
                      variant="outlined"
                      fullWidth
                      error={!isZDValid}
                      helperText={!isZDValid ? "This field is required." : ""}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} style={{ paddingLeft: "30px" }}>
                      {option.label}
                    </li>
                  )}
                  value={
                    selectZD
                      ? {
                        label:
                          zoneList.find((item) => item === selectZD)?.zone ||
                          departmentList.find((item) => item === selectZD)
                            ?.department ||
                          selectZD,
                        value: selectZD,
                      }
                      : null
                  }
                />

                {clickButtonName == "page" && (
                  <>
                    {" "}
                    <FormControl fullWidth error={!isFileValid}>
                      <InputLabel>Select Broadcast File</InputLabel>

                      <Select
                        name="Select File"
                        value={selectFile}
                        style={{ height: "55px" }}
                        label="Select Broadcast File"
                        onChange={handleFileSelect}
                        fullWidth
                      >
                        <MenuItem key="" value="">
                          Select
                        </MenuItem>
                        {fileList &&
                          fileList.map((item) => (
                            <MenuItem key={item.id} value={item.wavFile}>
                              {item.description}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>
                        {!isFileValid && "Please select a broadcast file."}
                      </FormHelperText>
                    </FormControl>
                  </>
                )}
                {clickButtonName == "message" && (
                  <>
                    <TextField
                      fullWidth
                      label="Type your message"
                      multiline
                      rows={4}
                      defaultValue=""
                      value={messageToBroadcast}
                      onChange={handleMessageChange}
                      error={!isMessageValid}
                      helperText={
                        isMessageValid
                          ? ""
                          : "Message cannot be empty. Please enter a message."
                      }
                    />
                  </>
                )}
              </>
            </DialogContent>
            <DialogActions
              sx={(theme) => ({
                ...CTLDialogContent(theme, { darkMode }),
                px: 3,
                pb: 2,
                pt: 1.5,
                borderTop: `1px solid ${alpha(theme.palette.info.main, 0.14)}`,
              })}
            >
              {clickButtonName == "messageHistory" ? (
                <MDButton
                  onClick={onCloseForm}
                  color="error"
                  variant="outlined"
                  sx={{ borderRadius: "999px", px: 2.5 }}
                >
                  Close
                </MDButton>
              ) : (
                <>
                  <MDButton
                    onClick={onCloseForm}
                    color="secondary"
                    variant="outlined"
                    sx={{ borderRadius: "999px", px: 2.5 }}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    color="success"
                    variant="gradient"
                    autoFocus
                    onClick={() => handleSaveButton()}
                    sx={{ borderRadius: "999px", px: 3 }}
                  >
                    Submit
                  </MDButton>
                </>
              )}
            </DialogActions>
          </Dialog>
        </Grid>
      </Grid>
      <Dialog open={open} maxWidth="sm" classes={{ dialog }}>
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            pb: 1.5,
            borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
            background: darkMode
              ? alpha(theme.palette.info.dark, 0.28)
              : alpha(theme.palette.common.white, 0.97),
          })}
          id="alert-dialog-title"
        >
          <MDTypography variant="h6" fontWeight="bold" sx={{ color: "info.main" }}>
            Send Message
          </MDTypography>
          <MDTypography variant="caption" sx={{ color: "text.secondary", mt: 0.4, display: "block" }}>
            Type your message to broadcast.
          </MDTypography>
        </DialogTitle>
        <DialogContent
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          style={{ paddingTop: "10px" }}
        >
          <MDBox sx={{ width: 500 }}>
            <TextField
              fullWidth
              id="outlined-multiline-flexible"
              variant="outlined"
              label="Type Message"
              value={message}
              onChange={handleMarkerMessageChange}
              multiline
              rows={6}
            />
          </MDBox>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={handleClickClose} color="secondary">
            Cancel
          </MDButton>
          <MDButton onClick={() => sendMessage()} color="success" autoFocus>
            Send
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openOnCreate}
        onClose={() => handleOnCreateClose()}
        maxWidth="md"
        classes={{ dialog }}
      >
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            pb: 1.5,
            borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
            background: darkMode
              ? alpha(theme.palette.info.dark, 0.28)
              : alpha(theme.palette.common.white, 0.97),
          })}
          id="alert-dialog-title"
        >
          <MDTypography variant="h6" fontWeight="bold" sx={{ color: "info.main" }}>
            Select Area Action
          </MDTypography>
          <MDTypography variant="caption" sx={{ color: "text.secondary", mt: 0.4, display: "block" }}>
            Choose a group to assign this area.
          </MDTypography>
        </DialogTitle>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDTypography variant="caption">{`Select Group`}</MDTypography>
          <Select
            value={selectedGroup}
            style={{ height: "55px" }}
            onChange={handleChangeGroup}
            name="Select Group"
            fullWidth
          >
            <MenuItem key="select" value="">
              Select
            </MenuItem>
            {groupList &&
              groupList.map((item) => (
                <MenuItem key={item.code} value={item}>
                  {item.description}
                </MenuItem>
              ))}
          </Select>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={() => handleOnCreateClose()} color="secondary">
            Cancel
          </MDButton>
          <MDButton
            onClick={() => handleOnCreateClose()}
            color="success"
            autoFocus
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
      <LiveGroupCall
        liveGroupCallOpen={liveGroupCallOpen}
        setLiveGroupCallOpen={setLiveGroupCallOpen}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}
